<script setup>
const showExternalPublicationAlert = ref(true)
</script>

<template>
  <transition
    name="fade"
    enter-active-class="transition ease-out duration-100"
    leave-active-class="transition ease-in duration-100"
  >
    <div v-if="showExternalPublicationAlert" class="flex items-center justify-between fixed w-[90%] max-w-[500px] left-1/2 -translate-x-1/2 top-20 md:w-auto md:max-w-none md:left-auto md:-translate-x-0 md:right-12 md:top-32 bg-blue-600 text-white p-4 border border-blue-700 shadow-2xl rounded-lg z-20">
      <div class="flex items-center space-x-3">
        <svg class="w-[24px] fill-white" viewBox="0 0 24 24"><path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" /></svg>
        <div>
          <div class="text-[14px] font-semibold">Evento externo</div>
          <div class="opacity-70 text-[12px]">La información podría no estar actualizada</div>
        </div>
      </div>
      <div class="cursor-pointer" @click="showExternalPublicationAlert = false">
        <svg class="w-[24px] fill-white" viewBox="0 0 24 24"><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg>
      </div>
    </div>
  </transition>
</template>

<style scoped>

</style>
